import React from 'react'
import { useDispatch } from 'react-redux'
import { deleteClientDelegate } from '../../../../../store/client'
//@ts-ignore
import LKModal, { actions as LKModalActions } from 'shared/LKModal'
import { actions as DetailsContainerActions } from '../../../../DetailsContainer'
import { deleteDelegateModalName } from '../../../constants'
import { translateLKMessage } from '../../../helpers'
import { AppDispatch } from 'src/store/index.d'
import { openDelegateDeleteModalParams } from 'src/features/ClientDetails/types'

const ClientDelegateDeleteModal = () => {
  const dispatch = useDispatch<AppDispatch>()

  function handleConfirm({
    ID,
    hash,
    RLClientID,
    HashSum_RLClientID_,
    delegateId,
    HashSum_DelegateID_,
  }: openDelegateDeleteModalParams) {
    dispatch(
      deleteClientDelegate({
        ClientID: ID,
        HashSum_ClientID_: hash,
        RLClientID,
        HashSum_RLClientID_,
        ID: delegateId,
        HashSum_DelegateID_,
      }),
    )
      .then((response: { type: string; meta: any; payload: any }) => {
        if (deleteClientDelegate.fulfilled.match(response)) {
          dispatch(
            DetailsContainerActions.fetchPage({
              type: 'Client',
              ID,
              hash,
              page: 'relations',
            }),
          )
        }
      })
      .catch((error) => {
        dispatch(
          LKModalActions.openInfo(translateLKMessage(error.Error.Message || error.Error.Text || error.Error.Code)),
        )
      })
  }

  return <LKModal.Confirmation name={deleteDelegateModalName} onConfirm={handleConfirm} />
}

export const openDelegateDeleteModal = (
  ID: number,
  hash: string,
  RLClientID: number,
  HashSum_RLClientID_: string,
  delegateId: number,
  HashSum_DelegateID_: string,
) =>
  LKModalActions.openConfirmation(deleteDelegateModalName, {
    ID,
    hash,
    RLClientID,
    HashSum_RLClientID_,
    delegateId,
    HashSum_DelegateID_,
  })

export default ClientDelegateDeleteModal
